module.exports = __webpack_public_path__ + "static/image/MK.png?8e67a37da59f9e07693ddc9f7def9e6b";